import React from 'react';
import './MarketingPanel.css';

/**
 * Certificate illustration shown on the marketing side of the auth layout.
 */
function CertificateIllustration() {
    return (
        <svg viewBox="0 0 460 300" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="36" cy="52" r="5" fill="#ffffff" opacity="0.5" />
            <circle cx="424" cy="60" r="7" fill="#ffffff" opacity="0.35" />
            <circle cx="416" cy="252" r="4" fill="#ffffff" opacity="0.5" />
            <circle cx="52" cy="240" r="6" fill="#ffffff" opacity="0.4" />

            <rect
                x="98"
                y="54"
                width="270"
                height="196"
                rx="18"
                fill="#ffffff"
                opacity="0.14"
                transform="rotate(6 98 54)"
            />

            <rect x="96" y="42" width="272" height="200" rx="18" fill="#ffffff" />
            <path
                d="M96 60C96 49.507 104.507 41 115 41H349C359.493 41 368 49.507 368 60V75H96V60Z"
                fill="#FAE4E5"
            />

            <rect x="120" y="104" width="150" height="12" rx="6" fill="#e5e7eb" />
            <rect x="120" y="128" width="210" height="10" rx="5" fill="#f3f4f6" />
            <rect x="120" y="148" width="180" height="10" rx="5" fill="#f3f4f6" />

            <circle cx="300" cy="176" r="46" fill="#FAE4E5" />
            <circle
                cx="300"
                cy="176"
                r="46"
                fill="none"
                stroke="#EC8D82"
                strokeWidth="1.5"
                strokeDasharray="5 6"
            />
            <path
                d="M300 150L322 159.5V176C322 191 313 201.5 300 207C287 201.5 278 191 278 176V159.5L300 150Z"
                fill="#CB001C"
            />
            <path
                d="M289 176L296 183L312 167"
                stroke="#ffffff"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <rect x="120" y="190" width="100" height="10" rx="5" fill="#e5e7eb" />
            <rect x="236" y="190" width="100" height="10" rx="5" fill="#e5e7eb" />

            <g transform="rotate(-8 392 96)">
                <rect x="392" y="96" width="56" height="44" rx="10" fill="#FAE4E5" />
                <path
                    d="M406 118L412 124L424 112"
                    stroke="#CB001C"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}

/**
 * Marketing Panel
 * Static Persian branding shown on the right side of the auth layout.
 */
function MarketingPanel() {
    return (
        <div className="auth-marketing">
            <div className="auth-marketing__content">
                <span className="auth-marketing__badge">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path
                            d="M7 1L12 3.5V7C12 9.9 9.8 12.2 7 13C4.2 12.2 2 9.9 2 7V3.5L7 1Z"
                            fill="currentColor"
                            opacity="0.9"
                        />
                        <path
                            d="M4.5 7L6.2 8.8L9.7 5.3"
                            stroke="#ffffff"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    گواهی دیجیتال امن
                </span>

                <h2 className="auth-marketing__title">
                    صدور و امضای گواهی دیجیتال، ساده و امن
                </h2>

                <p className="auth-marketing__subtitle">
                    سامانه گواهی دیجیتال، صدور، امضا و استعلام آنلاین گواهی‌ها و مدارک را در
                    یک بستر امن و قابل اعتماد فراهم می‌کند.
                </p>

                <div className="auth-marketing__illustration">
                    <CertificateIllustration />
                </div>
            </div>
        </div>
    );
}

export default MarketingPanel;
